/** Which capture a transcript turn came from: the user's own mic, or the meeting's system audio. */
export type AudioSource = 'microphone' | 'system'

export const AUDIO_SOURCE_LABELS: Record<AudioSource, string> = {
  microphone: 'Your microphone',
  system: 'System audio',
}
